<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <vs-button
                    v-if="actions.includes('create')"
                class="rounded-lg xs:w-full sm:w-auto"
                :to="{ name: `${routeConfigs.prefix}-create` }" >
                {{ $t("shared.add") }}
            </vs-button>
        </template>
        <template v-slot:datatable>
            <Datatable
                :config="datatableConfig"
                :elements="zones"
                :stripe="true"
                :draggable="draggable"
                :sst="true"
                :pagination="draggable ? null : pagination"
                @action="action"
                @filter="filter"
                @sort="sort"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>
import Datatable from '@/modules/Shared/Components/table/SKDataTable.vue'
import loader from "@/modules/Shared/Mixins/loader";
import DatatableService from '@/modules/Shared/Pages/sections/DatatableService';
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout"
import { unifyPaginatedResponse } from '@/modules/Shared/Helpers/apiResponseHelper'

export default {
    name: 'ListPage',
    mixins: [loader],
    components: {
        DatatablePageLayout,
        Datatable
    },
    props: {
        datatableConfig: Array,
        elementsAPIURL: String,
        commonFilters: Object,
        perPage: {
            type: Number,
            default: 30
        },
        draggable: {
            type: Boolean,
            default: false
        },
        actions: {
            type: Array,
            default: () => ['create', 'edit', 'delete']
        },
        routeConfigs: {
            type: Object,
        }
    },
    data () {
        return {
            zones: [],
            pagination: {},
            service: null,
        }
    },
    computed: {
        dataTableActions() {
            return this.actions.filter(action => action !== 'create')
        }
    },
    async created() {
        this.service = new DatatableService(this.elementsAPIURL, this.commonFilters, this.perPage)
        await this.getElements({}, 1)
    },
    methods: {
        async filter(parameters)
        {
            let filters = {}
            parameters.filters.forEach(function(item) { filters[item.field] = item.value });
            this.getElements(filters, parameters.page)
        },
        async sort(sortedElements)
        {
            await this.load(async () => {
                await this.service.sortElements(sortedElements)
            })
        },
        async getElements(filters, page) 
        {
            await this.load(async () => {
                let elements = []

                if (this.draggable) {
                    elements = await unifyPaginatedResponse(
                        this.service.fetchElements.bind(this.service),
                        filters
                    )
                    this.pagination = {
                        per_page: elements.length,
                        total: elements.length
                    }
                } else {
                    let response = await this.service.fetchElements(filters, page)
                    elements = response.data
                    this.pagination = {
                        per_page: response.per_page,
                        total: response.total
                    }
                }

                this.zones = elements.map(
                    zone => ({...zone, 'actions': this.dataTableActions})
                )
            })
        },
        action(type, uuid) {
            switch(type) {
                case 'edit':
                    this.$router.push({
                        name: `${this.routeConfigs.prefix}-edit`,
                        params: {
                            'elementUuid': uuid
                        }
                    });
                break;
                case 'delete':
                    this.deleteZone(uuid)
                break;
            }
        },
        async deleteZone(uuid) {
            await this.loadAndNotify(async () => {
                await this.service.deleteElement(uuid)
                await this.getElements({}, 1)
            })
        }
    }
}
</script>